  // Toast helper
  function showToast(message, { duration = 2000, type = 'success' } = {}) {
    const root = document.getElementById('toast-root') || (() => {
      const r = document.createElement('div');
      r.id = 'toast-root';
      r.style.position = 'fixed';
      r.style.left = '16px';
      r.style.bottom = '16px';
      r.style.zIndex = '9999';
      r.style.display = 'grid';
      r.style.gap = '8px';
      r.style.maxWidth = 'min(90vw, 360px)';
      document.body.appendChild(r);
      return r;
    })();

    const el = document.createElement('div');
    el.textContent = message;

    // Accent color by type
    let borderColor = '#22c55e'; // success
    if (type === 'error') borderColor = '#ef4444'; // error
    if (type === 'info') borderColor = '#3b82f6'; // info

    el.style.cssText = `
      font: 500 14px/1.3 system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
      color: #0a0a0a;
      background: #fff;
      border: 1px solid #e5e7eb;
      border-left: 6px solid ${borderColor};
      box-shadow: 0 8px 24px rgba(0,0,0,.12);
      border-radius: 12px;
      padding: 12px 14px;
      opacity: 0;
      transform: translateY(8px);
      animation: toast-in .12s ease-out forwards,
                 toast-out .18s ease-in forwards ${duration}ms;
    `;

    if (!document.getElementById('toast-anim')) {
      const style = document.createElement('style');
      style.id = 'toast-anim';
      style.textContent = `
        @keyframes toast-in {
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes toast-out {
          to { opacity: 0; transform: translateY(8px); }
        }
      `;
      document.head.appendChild(style);
    }

    root.appendChild(el);

    el.addEventListener('animationend', (e) => {
      if (e.animationName === 'toast-out') el.remove();
    });

    el.addEventListener('click', () => el.remove());
  }

  // ✅ Handler wrapper with delay
  function handleToast(message, options = {}, delay = 0) {
    setTimeout(() => {
      showToast(message, options);
    }, delay);
  }
